import { render, staticRenderFns } from "./sky-switch.vue?vue&type=template&id=5e598e97&scoped=true"
import script from "./sky-switch.vue?vue&type=script&lang=js"
export * from "./sky-switch.vue?vue&type=script&lang=js"
import style0 from "./sky-switch.vue?vue&type=style&index=0&id=5e598e97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e598e97",
  null
  
)

export default component.exports